import EditPdcCard from './EditPdcCard'

export default EditPdcCard
